module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column align-items-center"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/T3NCz_IVgv4?ecver=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("Zabieg z zastosowaniem urządzenia PlasmaIQ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319fba4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing/components/SectionRight.vue
// module id = 44
// module chunks = 0